import api from './axios';

// Get all important dates
export const getImportantDates = async (params = {}) => {
  try {
    const response = await api.get('/important-dates', { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get single important date
export const getImportantDate = async (id) => {
  try {
    const response = await api.get(`/important-dates/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Create important date
export const createImportantDate = async (data) => {
  try {
    const response = await api.post('/important-dates', data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Update important date
export const updateImportantDate = async (id, data) => {
  try {
    const response = await api.patch(`/important-dates/${id}`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Delete important date
export const deleteImportantDate = async (id) => {
  try {
    const response = await api.delete(`/important-dates/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Bulk delete important dates
export const bulkDeleteImportantDates = async (ids) => {
  try {
    const response = await api.post('/important-dates/bulk-delete', { ids });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
